import { VALIDATE_PACKAGE_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export var ParcelNumberValidationStatus;
(function (ParcelNumberValidationStatus) {
    ParcelNumberValidationStatus["SUCCESS"] = "SUCCESS";
    ParcelNumberValidationStatus["EXPIRED"] = "EXPIRED";
    ParcelNumberValidationStatus["FAIL"] = "PARCEL_NOT_FOUND";
})(ParcelNumberValidationStatus || (ParcelNumberValidationStatus = {}));
export const postValidateParcelNumber = async (orderNumber, parcelNumber, commercetoolsProject) => {
    const { data } = await Network.post(VALIDATE_PACKAGE_ENDPOINT, {
        orderNumber,
        parcelNumber,
        project: commercetoolsProject,
    });
    return data;
};
